var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "info",
  "use": "info-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"info\"><circle cx=\"10\" cy=\"10\" r=\"9.5\" stroke=\"#707070\" /><path fill=\"#707070\" d=\"M10.9 8.4H9.1v6h1.8zM11 6c0 .583-.417 1-1 1s-1-.417-1-1 .417-1 1-1 1 .417 1 1\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol